module.exports = __webpack_public_path__ + "img/2fef215.jpg";